<!-- Request List Header -->
<div class="card" id="requestlist_card_override">
    <div class="row">
        <div class="col-12">
            <div class="card calendar date_time_picker" id="reportrangeRequests">
                <div class="card-body" id="custom_body">
                    <em class="fa fa-calendar"></em>&nbsp;
                    <span></span>
                    <em class="fa fa-caret-down"></em>
                </div>
            </div>
        </div>
    </div>
    <div id="sd_requests_header" [ngClass]="{ 'disabled' : isAnyRequestInEditMode()}">

        <div class="card-body pt-1 pb-1 d-flex justify-content-start request_list_heading" id="request_list_heading">
            <div style="flex: 0 0 20px;">&nbsp;</div>
            <div (click)="sort('incidentId')" style="flex: 0 0 100px;" id="incidentId">
                <em class="fa fa-sort"
                    [ngClass]="{'fas fa-sort-down': (column == 'incidentId' && isDesc), 'fas fa-sort-up': (column == 'incidentId' && !isDesc) }"
                    aria-hidden="true">
                </em>
                {{ 'RequestsList.requestNumber' | translate }}
            </div>

            <div style="flex: 0 0 28px;">&nbsp;</div>

            <div (click)="sort('item')" class="data d-none d-lg-block d-md-block" id="item">
                <em class="fa fa-sort"
                    [ngClass]="{'fas fa-sort-down': (column == 'item' && isDesc), 'fas fa-sort-up': (column == 'item' && !isDesc) }"
                    aria-hidden="true">
                </em>
                {{ 'RequestsList.item' | translate }}
            </div>

            <div (click)="sort('reportDate')" class="data d-none d-lg-block" id="reportDate">
                <em class="fa fa-sort"
                    [ngClass]="{'fas fa-sort-down': (column == 'reportDate' && isDesc), 'fas fa-sort-up': (column == 'reportDate' && !isDesc) }"
                    aria-hidden="true">
                </em>
                {{ 'RequestsList.created' | translate }}
            </div>

            <div (click)="sort('lastActionDate')" class="data d-none d-lg-block" id="lastActionDate">
                <em class="fa fa-sort"
                    [ngClass]="{'fas fa-sort-down': (column == 'lastActionDate' && isDesc), 'fas fa-sort-up': (column == 'lastActionDate' && !isDesc) }"
                    aria-hidden="true">
                </em>
                {{ 'RequestsList.updated' | translate }}
            </div>

            <div style="flex: 0 0 5px;">&nbsp;</div>
            <div (click)="sort('statusType')" class="data" id="statusType">
                <em class="fa fa-sort"
                    [ngClass]="{'fas fa-sort-down': (column == 'statusType' && isDesc), 'fas fa-sort-up': (column == 'statusType' && !isDesc) }"
                    aria-hidden="true">
                </em>
                {{ 'RequestsList.status' | translate }}
            </div>
            <div style="flex: 0 0 20px;">&nbsp;</div>
            <div style="flex: 0 0 20px;">&nbsp;</div>
            <div style="flex: 0 0 20px;">&nbsp;</div>
            <div style="flex: 0 0 20px;">
            <em class="fa fa-ellipsis-v header" data-toggle="tooltip" data-placement="right" title="{{'RequestsList.requestaction' | translate}}"> </em> </div>
        </div>
    </div>
    <!-- End Request List Header -->

    <!-- Apply On Scroll Loading -->
    <!-- Request List Content -->
    <div appInfinteScroll (scrolledEnd)="scrollEnd()" (scrolledCur)="scrollCur()">
        <div class="card" id="sd_requests_data"
            *ngFor="let list of requestBasicInfoResponse;let i=index;trackBy:trackByRequests"
            (click)="sendRequestNumber(i)">
            <div [className]="showExpanded ? '' : 'collapsed'" data-toggle="collapse"
                [attr.id]="'#zsd-requestdetail' + i" [attr.aria-expanded]="showExpanded ? true : false"
                [attr.aria-controls]="'#zsd-requestdetail' + i" [attr.data-target]="'#zsd-requestdetail' + i">
                <div class="card-body d-flex justify-content-start request-list-content" id="request_list_content">
                    <!-- This need to be change when develop actual User Story -->
                    <div style="flex: 0 0 30px;" class="requestList_image">
                        <img class="request-list-arrow" src="img/arrow.png" />
                    </div>
                    <div style="flex:0 0 30px;">
                        <div id="requestTypeIcon_Container" class="requestList_image">
                            <img *ngIf="list.requestType === '1000'" src="img/incident.jpg" width=18 height=18
                                data-toggle="tooltip" data-placement="right"
                                title="{{ 'RequestsList.incident' | translate }}" />
                            <img *ngIf="list.requestType === '7000'" src="img/request.jpg" width=18 height=18
                                data-toggle="tooltip" data-placement="right"
                                title="{{ 'RequestsList.servicerequest' | translate }}" />
                            <img *ngIf="list.requestType === '3000'" src="img/change.jpg" width=18 height=18
                                data-toggle="tooltip" data-placement="right"
                                title="{{ 'RequestsList.changerequest' | translate }}" />
                            <img *ngIf="list.requestType === '2000'" src="img/problem.jpg" width=18 height=18
                                data-toggle="tooltip" data-placement="right"
                                title="{{ 'RequestsList.problem' | translate }}" />
                        </div>
                    </div>
                    <div style="flex: 0 0 100px;">{{ list.requestNumber }}</div>
                    <div class="data d-none d-lg-block d-md-block" data-toggle="tooltip" data-placement="right"
                    title="{{ list.item }}" *ngIf="list.item.length > 64">{{ list.item.substr(0,63) }}..</div>
                    <div class="data d-none d-lg-block d-md-block" data-toggle="tooltip" data-placement="right"
                    title="{{ list.item }}" *ngIf="list.item.length <= 64">{{ list.item }}</div>
                    <div class="data d-none d-lg-block">{{ list.createdDate }}</div>
                    <div class="data d-none d-lg-block">{{ list.updatedOn }}</div>

                    <div style="flex: 0 0 5px;">&nbsp;</div>
                    <div class="data">{{ list.status }}</div>
                    <div style="flex: 0 0 20px;">
                        <span *ngIf="list.isOnNeedinfo" id="requestlist_needInfo" class="fas fa-allergies"></span>
                    </div>
                    <div style="flex: 0 0 20px;">
                        <span *ngIf="list.isAwaitingMyApproval"><img src="img/awaitingMyApproval.png" /></span>
                    </div>
                    <div style="flex: 0 0 30px;">
                        <span *ngIf="list.hasAttachment" id="requestlist_attachment" class="fa fa-paperclip"
                            (click)="getListAttachment(list.requestNumber,$event,'#zsd-attachment')" data-toggle="modal"
                            data-target="#zsd-attachment"></span>
                    </div>


                    <div style="flex: 0 0 20px;">
                        <img src="img/three_dots.png" class="dropdown-toggle" [attr.id]="'#zsd-dropdownMenu'+i"
                            data-toggle="dropdown" [attr.aria-haspopup]="true" [attr.aria-expanded]="false"
                            (click)="openDropdown(list.requestNumber)" />
                        <div class="dropdown-menu dropdown-menu-right" [attr.id]="'zsd-dropdownMenu'+i"
                            [attr.aria-labelledby]="'#zsd-dropdownMenu'+i">
                            <a class="dropdown-item" *ngFor="let action of actions"
                                (click)="sendOption(list, action, '#zsd-requestdetail'+i, $event,'#zsd-dropdownMenu'+i)">{{'Actions.'+action | translate}}</a>
                        </div>
                    </div>
                </div>
                <div class="card-body" id="request_list_subject"
                    *ngIf="showSubject && list.subject!==null && list.subject.trim().length > 0">
                    {{ 'RequestsList.subject' | translate }}: {{ list.subject }}
                </div>
            </div>
            <!-- Request List Detail Component -->
            <div [attr.id]="'zsd-requestdetail' + i" [className]="showExpanded ? 'collapse show' : 'collapse'">
                <div *ngIf="showExpanded || (itemClicked.length > 0 && i == itemClicked[itemClicked.indexOf(i)])">
                    <zsd-requestdetail [index]="i" [requestNumber]="list.requestNumber"
                        [detArrIndex]="itemClicked.indexOf(i)" [clickedAct]="clickedAction"
                        [selectedAction]="list.action"></zsd-requestdetail>
                </div>
            </div>
            <!-- End Request List Content -->
        </div>


        <div *ngIf="requestBasicInfoResponse?.length == 0 && !isLoading" class="text-center">
            <div class="card">
                <div class="card-body" id="c_no_kba_message">
                    {{ noRecords | translate }}
                </div>
            </div>
        </div>

        <!-- Spinner -->
        <div *ngIf="isLoading || spinnerStart" id="spinner" role="progressbar">
            <div class="text-center col-12">
                <zsd-spinner></zsd-spinner>
            </div>
        </div>

    </div> <!-- End of Card-->



    <!--Attachment  Modal -->
    <div class="modal" id="zsd-attachment">
        <div class="modal-dialog modal-dialog-centered modal-md">
            <div class="modal-content" id="modal_content_override">
                <div class="modal-header" id="attachment-header">
                    <div id="attachment_header_text">{{ 'RequestsList.attachments' | translate }}</div>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body" id="modal_body_override">
                    <!-- Spinner -->
                    <zsd-spinner *ngIf="attachmentIsLoading || attachmentSpinnerStart" id="spinner" 
                    role="progressbar" class="custom-spinner">
                    </zsd-spinner>
                    <div *ngFor="let attachment of reqAttachmentResponse" class="attachment-detail">
                        <div class="attachment-name">
                            <a id="attachment_link_text"
                                (click)="attachmentDetails(attachment)">{{attachment.attachmentName}}</a>
                        </div>
                        <div>
                            <span>{{attachment.attachmentSize}}</span>
                        </div>


                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End of Attachment Modal -->

    <!-- End of On Scroll Load Div -->

    <div *ngIf="(scrollEndReached && requestBasicInfoResponse?.length > 20) " class="text-center">
        <div class="card">
            <div class="card-body" id="c_no_request_message">
                {{ 'CommonStrings.endOfScroll' | translate }}
            </div>
        </div>
    </div>